import { VCSLevelModel } from "@/models/title-list-model";
import { Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { VersionGroupModule } from "@/modules/versiongroup";
import { VersionGroupModel } from "@/services/version-group";

@Component({
	components: {
		Select,
		Option: Select.Option
	},
	props: {
		duration: Number
	}
})
export default class VersionGroupUnitsSelect extends Vue {
	@Prop({ default: [] }) vcsLevelUnits!: VCSLevelModel[];
	@Prop() isFilterInComponentObjective?: boolean;
	public startUnit: number | null = null;
	public endUnit: number | null = null;
	public versionGroupModule = VersionGroupModule;
	public filteredStartUnits: VCSLevelModel[] = [];
	public filteredEndUnits: VCSLevelModel[] = [];
	public selectedVersionGroupId = "";

	get selectedVersionGroup() {
		return (
			VersionGroupModule.versionGroups.find((v) => v.id === this.selectedVersionGroupId) ||
			({} as VersionGroupModel)
		);
	}

	get startUnitId() {
		const unitObject = this.filteredStartUnits.find((u) => u.unit == this.startUnit);
		return unitObject && unitObject.id;
	}

	get endUnitId() {
		const unitObject = this.filteredEndUnits.find((u) => u.unit == this.endUnit);
		return unitObject && unitObject.id;
	}

	@Watch("selectedVersionGroupId", { deep: true })
	getVersionGroupUnits() {
		const vcsUnits = this.vcsLevelUnits.filter(
			(u) => u.curriculumType === this.selectedVersionGroup.curriculumType
		);
		// Please do not change it to "return u", it is the deep clone.
		this.filteredStartUnits = vcsUnits.map((u) => {
			return { ...u };
		});
		this.filteredEndUnits = vcsUnits.map((u) => {
			return { ...u };
		});
		this.startUnit = this.filteredStartUnits.length && this.filteredStartUnits[0].unit;
		this.endUnit = this.filteredEndUnits.length && this.filteredEndUnits[this.isFilterInComponentObjective ? 0 : 4].unit;
		this.$emit("unitObject", { startUnitId: this.startUnitId, endUnitId: this.endUnitId });

		this.disabledEndUnits();
		this.disabledStartUnits();
	}

	/*
		* Since the objectices/tree... api only takes one version group as an argument only one versiongroup 
		* is selected at a time and the other is set to none( for both GS and LS ).
	*/

	@Watch("versionGroupModule.selectedGsVersion", { immediate: true })
	isGSVersionUpdated() {
		if (this.versionGroupModule.selectedGsVersion !== "-1") {
			this.versionGroupModule.setLsVersion("-1");
			this.selectedVersionGroupId = this.versionGroupModule.selectedGsVersion;
		}
	}

	@Watch("versionGroupModule.selectedLsVersion", { immediate: true })
	isLSVersionUpdated() {
		if (this.versionGroupModule.selectedLsVersion !== "-1") {
			this.versionGroupModule.setGsVersion("-1");
			this.selectedVersionGroupId = this.versionGroupModule.selectedLsVersion;
		}
	}

	disabledEndUnits() {
		this.filteredEndUnits.map((u) => {
			u.disabled = u.unit < (this.startUnit as number);
			return u;
		});
	}

	disabledStartUnits() {
		this.filteredStartUnits.map((u) => {
			u.disabled = u.unit > (this.endUnit as number);
			return u;
		});
	}

	handleStartUnit(value: number): void {
		this.startUnit = value;
		this.disabledEndUnits();
		this.$emit("unitObject", { startUnitId: this.startUnitId, endUnitId: this.endUnitId });
	}

	handleEndUnit(value: number): void {
		this.endUnit = value;
		this.disabledStartUnits();
		this.$emit("unitObject", { startUnitId: this.startUnitId, endUnitId: this.endUnitId });
	}
}
